/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Home from '../components/home';
import SingleHome from '../components/singleHome';
import Loader from '../components/loader';

export default () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const isInitialized = inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect;

  if (!isInitialized) {
    return <Loader />;
  }

  return isAuthenticated
    ? <Home />
    : <SingleHome />;
};
